import React from "react";
import ReactDOM from 'react-dom';

export default class IFrame extends React.Component {

    constructor(props) {
        super(props);
        this.handleLoad = this.handleLoad.bind(this);
    }

    componentDidMount() {
        this.node.addEventListener("load", this.handleLoad);
    }

    componentWillUnmount() {
        this.node.removeEventListener("load", this.handleLoad);
    }

    handleLoad() {
        this.iframeHead = this.node.contentDocument.head;
        this.iframeRoot = this.node.contentDocument.body;
        this.forceUpdate();
    };

    render() {
        const { head, ...rest } = this.props;
        const componentDocument = (this.node) ? this.node.contentDocument : null ;

        const children = React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child, {...this.props, document: componentDocument});
        });

        return (
            <iframe className="ssmt3-widget" srcDoc={`<!DOCTYPE html>`} {...rest} ref={node => (this.node = node)}>
                {this.iframeHead && ReactDOM.createPortal(head, this.iframeHead)}
                {componentDocument ? (this.iframeRoot && ReactDOM.createPortal(children, this.iframeRoot)) : null}
            </iframe>
        );
    }
}